import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { Popup } from 'semantic-ui-react';
import { checkOverflow } from './TextOverflow.utils';
import './TextOverflow.css';
var defaultProps = {
  className: '',
  wide: ''
};
export default function TextOverflow(_ref) {
  var content = _ref.content,
    className = _ref.className,
    wide = _ref.wide;
  var overflowingText = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  function handleTogglePopup() {
    if (checkOverflow(overflowingText.current)) {
      setOpen(function (prev) {
        return !prev;
      });
    }
  }
  function handleShowPopup() {
    if (checkOverflow(overflowingText.current)) {
      setOpen(true);
    }
  }
  function handleHidePopup() {
    if (checkOverflow(overflowingText.current)) {
      setOpen(false);
    }
  }
  var contentElement = /*#__PURE__*/React.createElement("div", {
    role: "contentinfo",
    className: "foundation-overflow ".concat(className),
    ref: overflowingText
  }, content);
  var contentElementWithEvents = /*#__PURE__*/React.cloneElement(contentElement, {
    onClick: handleTogglePopup,
    onMouseEnter: handleShowPopup,
    onMouseLeave: handleHidePopup
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, contentElementWithEvents, /*#__PURE__*/React.createElement(Popup, {
    context: overflowingText,
    on: ['hover', 'click'],
    content: content,
    position: "bottom center",
    className: "foundation-overflow-popup-text",
    wide: wide,
    open: open
  }));
}
TextOverflow.defaultProps = defaultProps;